import './chart.style.less'

import { debounce, isEmpty } from 'lodash'

import { Line } from 'react-chartjs-2'
import MainWrapper from './MainWrapper'
import { useState, useLayoutEffect } from 'react'

interface props {
  title: string
  sign?: string
  showLegend?: boolean
  data: any
  id: string
  target: boolean
  periods?: string[]
  onPeriodChange?: (period: string) => any
}

function LineChart(props: props) {
  const {
    data,
    showLegend = true,
    title,
    sign = '',
    id,
    target = false,
    periods = [],
    onPeriodChange = () => {},
  } = props

  const [plugins, setPlugins] = useState<any>()

  useLayoutEffect(() => {
    const plugins = [
      {
        id: 'liveboard',
        beforeInit: function (chart) {
          // Get reference to the original fit function
          const originalFit = chart.legend.fit
          // Override the fit function
          chart.legend.fit = function fit() {
            // Call original function and bind scope in order to use `this` correctly inside it
            originalFit.bind(chart.legend)()
            this.height += 10
          }
        },
      },
    ]

    setPlugins(plugins)
  }, [])

  const [options, setOption] = useState<any>({
    plugins: {
      legend: {
        position: 'top' as const,
        display: showLegend,
        padding: { top: -10 },
        labels: {
          usePointStyle: true,
          pointStyle: 'rectRounded',
        },
      },
      datalabels: {
        align: 'top' as const,
        anchor: 'end' as const,
        formatter: (val) => {
          return val + sign
        },
      },
    },
    layout: {
      padding: { top: 10, left: 20, right: 20 },
    },
    scales: {
      x: {
        stacked: false,
      },
      y: {
        stacked: false,
        ticks: {
          callback: function (value) {
            return value + sign
          },
        },
      },
    },
  })

  const onTarget = (value) => {
    if (!isEmpty(value)) {
      setOption({
        ...options,
        plugins: {
          ...options.plugins,
          annotation: {
            annotations: {
              line1: {
                type: 'line',
                yMin: value,
                yMax: value,
                borderColor: '#ADADAD',
                borderWidth: 3,
                borderDash: [4],
              },
            },
          },
        },
      })
    } else {
      const tmpValue = {
        ...options,
        plugins: {
          ...options.plugins,
        },
      }
      delete tmpValue.plugins.annotation
      setOption(tmpValue)
    }
  }

  return (
    <MainWrapper
      onTarget={debounce(onTarget, 500)}
      isTarget={target}
      id={id}
      title={title}
      onPeriodChange={onPeriodChange}
      periods={periods}
    >
      <Line redraw data={data} options={options as any} plugins={plugins} />
    </MainWrapper>
  )
}
export default LineChart
